import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '../../state'
import ContextAttributes from './ContextAttributes'
import ContextCoursesTable from './ContextCoursesTable'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'

const ContextDetails = ({contextId}) => {
  const [currentState] = useStateValue()
  const [context, setContext] = useState(null)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(endpoints.getContextDetails({ contextId: contextId }))
        setContext(resp.data.context)
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
  }, [currentState.reloadSwitch])

  let component =
    context === null ? (
      <p>Loading ...</p>
    ) : (
      <Fragment>
        <ContextAttributes context={context} />
        <ContextCoursesTable context={context} />
      </Fragment>
    )

  return <Fragment>{component}</Fragment>
}

ContextDetails.propTypes = {
  contextId: PropTypes.string.isRequired,
}

export default ContextDetails
